(() => {
  const cardSelector = '.cf-product-card';
  const swatchSelector = `${cardSelector} [data-swatch-button]`;
  let requestSequence = 0;

  function getResponsiveImageUrl(source, card) {
    try {
      const url = new URL(source, window.location.href);
      const renderedWidth = card.querySelector('[data-product-media-container]')?.clientWidth || card.clientWidth;
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.min(1400, Math.max(600, Math.ceil((renderedWidth * pixelRatio) / 100) * 100));

      url.searchParams.set('width', width);
      return url.href;
    } catch (error) {
      return source;
    }
  }

  function updateVariantLinks(card, variantId) {
    card.querySelectorAll('[data-grid-link]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        url.searchParams.set('variant', variantId);
        link.href = url.href;
      } catch (error) {
        // Keep the original destination when a theme app provides a non-standard URL.
      }
    });

    const quickView = card.querySelector('[data-button-quick-view]');
    if (quickView) {
      quickView.setAttribute('data-variant-id', variantId);
    }
  }

  function markSelectedSwatch(card, selectedButton) {
    card.querySelectorAll('[data-swatch-button]').forEach((button) => {
      const isSelected = button === selectedButton;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-selected', String(isSelected));
    });
  }

  function commitImage(card, imageUrl, imageId, colorName) {
    const primaryImage = card.querySelector('[data-product-image]');
    const secondaryImage = card.querySelector('[data-product-image-secondary]');

    if (!primaryImage) return;

    const prepareImage = (element) => {
      element.removeAttribute('data-bgset');
      element.classList.remove('lazyload', 'lazyloading');
      element.classList.add('lazyloaded');
      element.style.backgroundImage = `url("${imageUrl}")`;
    };

    if (secondaryImage) {
      prepareImage(secondaryImage);
      secondaryImage.classList.add('product__media--featured-visible');
    }

    window.setTimeout(() => {
      prepareImage(primaryImage);
      if (imageId) primaryImage.setAttribute('data-grid-image-target', imageId);
      if (colorName) primaryImage.setAttribute('aria-label', colorName);
      secondaryImage?.classList.remove('product__media--featured-visible');
      card.classList.remove('is-swatch-loading');
    }, secondaryImage ? 220 : 0);
  }

  function selectSwatch(button) {
    const card = button.closest(cardSelector);
    const swatch = button.querySelector('[data-swatch]');
    if (!card || !swatch) return;

    const variantId = swatch.getAttribute('data-swatch-variant');
    const imageSource = swatch.getAttribute('data-swatch-image');
    const imageId = swatch.getAttribute('data-swatch-image-id');
    const colorName = button.getAttribute('data-value') || swatch.getAttribute('data-swatch') || '';

    markSelectedSwatch(card, button);
    if (variantId) updateVariantLinks(card, variantId);
    if (!imageSource) return;

    const imageUrl = getResponsiveImageUrl(imageSource, card);
    const requestId = String(++requestSequence);
    card.dataset.swatchImageRequest = requestId;
    card.classList.add('is-swatch-loading');

    const preloader = new Image();
    preloader.onload = () => {
      if (card.dataset.swatchImageRequest !== requestId) return;
      commitImage(card, imageUrl, imageId, colorName);
    };
    preloader.onerror = () => {
      if (card.dataset.swatchImageRequest === requestId) {
        card.classList.remove('is-swatch-loading');
      }
    };
    preloader.src = imageUrl;
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(swatchSelector);
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      selectSwatch(button);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const button = event.target.closest(swatchSelector);
    if (!button) return;

    event.preventDefault();
    selectSwatch(button);
  });
})();
